<template>
  <div class="parent-box">
    <div class="content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.getLists"
          :key="i + '-list'"
          :border="false"
        >
          <template #value>
            <p>领取{{ item.coupon_name }}</p>
            <p>
              领取时间：<span>{{ item.get_time }}</span>
            </p>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted } from "vue";
import { useStore } from "vuex";
import { monthCardCouponRecord } from "@/api/yzuser.js";
import { setToken, getToken, getUid } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { Toast } from "vant";
import { stat } from "fs";
export default {
  name: "get_record",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
      loading: false,
      finished: false,
    });
    onMounted(() => {});

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      monthCardCouponRecord({
        // uid: 788,
        uid: getQueryString("uid"),
        // uid: localStorage.getItem('uid'),
        pagecode: pagecode,
      }).then((res) => {
        if (res.data.code == 1) {
          console.log(res);
          totalpage = res.data.data.total_page;
          if (pagecode > res.data.data.total_page) {
            state.finished = true;
            return;
          }

          state.getLists = state.getLists.concat(res.data.data.lists);
        } else {
          Toast(res.data.msg);
          state.finished = true;
        }
        console.log(pagecode);
        pagecode++;
        state.loading = false;
        console.log(state.getLists);
      });
    };
    const goBack = () => {
      window.document.location = "goback://";
    };

    return {
      state,
      onLoad,
      goBack,
    };
  },
};
</script>
<style scoped="scoped" src="../../../styles/van-sticky-nav.css"></style>
<style scoped="scoped">
.van-nav-bar {
  margin-top: 60px;
}

:deep(.van-nav-bar) {
  background: #090F1A;
}
:deep(.van-nav-bar__title) {
  color: #333;
}

.parent-box {
  /* padding-top: 160px; */
  height: 100vh;
  width: 100vw;
  overflow: auto;
  background-color: #161b1f;
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 100px;
}

.van-cell {
  width: 686px;
  height: 154px;
  background-color: #1F2430;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
}

.van-cell p:nth-of-type(1) {
  font-size: 32px;
  color: #fff;
  font-weight: bold;
  /* margin-bottom: 12px; */
}

.van-cell p:nth-of-type(2) {
  /* margin-top: 12px; */
  font-size: 24px;
  color: #fff;
}
</style>
